import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation SuggestAnswerForQuestion(
    $customerId: ID!
    $question: String!
    $allInstructionsData: JSON!
    $urlExtractions: [UrlExtractionInput!]
  ) {
    suggestAnswerForQuestion(
      customerId: $customerId
      question: $question
      allInstructionsData: $allInstructionsData
      urlExtractions: $urlExtractions
    ) {
      answer
    }
  }
`;

export const suggestAnswerForQuestion = ({
  customerId,
  question,
  allInstructionsData,
  urlExtractions,
}) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, question, allInstructionsData, urlExtractions },
  }).then(({ data }) => getSingleProp(data));
};
